import script from "./DashboardHeaderAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHeaderAdmin.vue?vue&type=script&setup=true&lang=js"

import "./DashboardHeaderAdmin.vue?vue&type=style&index=0&id=2c84b5af&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c84b5af"]])

export default __exports__